module.exports = __webpack_public_path__ + "static/media/video-final.60dfefa7.mp4";